function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import PictureWithLinkComponent from "components/core/picture-with-link/picture-with-link-component";
import SecondaryLinkItemComponent from "segments/desktop/header/layouts/base-header/secondary-header/secondary-link-item/secondary-link-item-component";
import { getMiniSiteLogo, getMiniSiteLinks } from "client/services/cluster-config-service/cluster-config-service";
import { isSameUrlWithoutQueryParams } from "utils/url";
import { withRouter } from "next/router";
import { StyledSecondaryHeaderDesktopComponent } from "./secondary-header-desktop-component.scss";
class SecondaryHeaderDesktopComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledSecondaryHeaderDesktopComponent, {
            "aria-label": "Secondary",
            className: "secondary-header-desktop-component",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "secondary-header-desktop-content",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "logo-wrapper",
                        children: this.renderLogo()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "links-wrapper",
                        children: this.renderLinks()
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "renderLogo", ()=>{
            const { pageClusterConfig, useProductMiniSiteConfig } = this.props;
            const logo = getMiniSiteLogo(pageClusterConfig, {
                useProductMiniSiteConfig
            });
            return /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
                className: "secondary-header-logo-image",
                src: logo === null || logo === void 0 ? void 0 : logo.src,
                alt: logo === null || logo === void 0 ? void 0 : logo.alt,
                href: logo === null || logo === void 0 ? void 0 : logo.url
            });
        });
        _define_property(this, "renderLinks", ()=>{
            const { pageClusterConfig, router, useProductMiniSiteConfig } = this.props;
            const links = getMiniSiteLinks(pageClusterConfig, {
                useProductMiniSiteConfig
            });
            return links.map((link, index)=>/*#__PURE__*/ _jsx("div", {
                    className: "secondary-link-item-wrapper",
                    children: /*#__PURE__*/ _jsx(SecondaryLinkItemComponent, {
                        url: link === null || link === void 0 ? void 0 : link.url,
                        title: link === null || link === void 0 ? void 0 : link.text,
                        isSelected: isSameUrlWithoutQueryParams(link === null || link === void 0 ? void 0 : link.url, router === null || router === void 0 ? void 0 : router.asPath)
                    })
                }, index));
        });
    }
}
export default withRouter(withGenericConfig(SecondaryHeaderDesktopComponent));
